export default "__VITE_ASSET__1ifucyzd__"